import * as yup from 'yup';
import api from '@/services/api';
import { DOCUMENT_TYPE } from "@/utils/constants";
type DocumentRule = {
  length: number;
  type: 'numeric' | 'alphanumeric';
  exact: boolean;
  min: number;
};
const documentRules: Record<number, DocumentRule> = {
  [DOCUMENT_TYPE.DNI]: { length: 8, type: 'numeric', exact: true, min: 8 },
  [DOCUMENT_TYPE.CARNET_EXTRANJERIA]: { length: 12, type: 'alphanumeric', exact: false, min: 3 },
  [DOCUMENT_TYPE.PASAPORTE]: { length: 12, type: 'alphanumeric', exact: false, min: 3 }
};
export const playerSchema = yup.object({
  companyId: yup.string().required('Empresa/Institución es requerido'),
  email: yup.string()
          .required('Username es requerido')
          //.email('Correo electrónico inválido')
          .test(
            'checkDuplicateUsername',
            'El Username ya existe',
            async function (value) {
              const { id } = this.options.context || {};
              if (!value) return true; // Skip if empty — let `.required` handle it
      
              try {
                const response = await api.get(`/player/validate-username?idplayer=${id}&username=${value}`);
      
                return !response.data; 
              } catch (error) {
                return this.createError({
                  message: 'Error al validar el nombre de usuario',
                });
              }
            }
          ),
  firstName: yup.string().required('Nombre es requerido'),
  lastName: yup.string().required('Apellido es requerido'),
  documentTypeId: yup
    .number()
    .nullable()
    .when('documentNumber', {
      is: (val: string | null | undefined) => !!val,
      then: (schema) => schema.required('Debe seleccionar el tipo de documento'),
      otherwise: (schema) => schema.nullable()
    }),
    documentNumber: yup
    .string()
    .nullable()
    .test('document-validation', 'Documento inválido', function (value) {
      const { documentTypeId } = this.parent as {
        documentTypeId?: number | null;
      };
      if (!value) return true;
      if (!documentTypeId) return true;
      const rule = documentRules[documentTypeId];
      if (!rule) return true;

      if (rule.type === 'numeric' && !/^\d+$/.test(value)) {
        return this.createError({ message: 'El documento debe ser numérico' });
      }

      if (rule.type === 'alphanumeric' && !/^[a-zA-Z0-9]+$/.test(value)) {
        return this.createError({ message: 'El documento debe ser alfanumérico' });
      }

      if (rule.exact && value.length !== rule.length) {
        return this.createError({
          message: `El documento debe tener exactamente ${rule.length} caracteres`
        });
      }
      if (!rule.exact && value.length > rule.length) {
        return this.createError({
          message: `El documento debe tener máximo ${rule.length} caracteres`
        });
      }
      if (!rule.exact && rule.min && value.length < rule.min) {
        return this.createError({
          message: `El documento debe tener al menos ${rule.min} caracteres`
        });
      }
      return true;
    }),
    phoneNumber: yup
    .string()
    .nullable()
    .transform((value) => value === '' ? null : value)
    .matches(/^\d+$/, 'El teléfono/celular solo debe contener números')
    .min(7, 'El teléfono/celular debe tener mínimo 7 dígitos')
    .max(20, 'El teléfono/celular debe tener máximo 20 dígitos')
});